import { assetUrl, homeUrl } from "@/lib/assets";
"use client";

import React, { useRef } from "react";
import { ArrowLeft, ArrowRight, ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const cardsData = [{
  id: 1,
  title: "HISTORIA",
  subtitle: "Orígenes y fundamentos desde 1914",
  link: "/creencias-2/",
  image: {
    src: assetUrl("36918933_1852040114852363_672322566924271616_n.jpg"),
    alt: "Fotografía histórica de los fundadores de las Asambleas de Dios"
  }
}, {
  id: 2,
  title: "MISIÓN",
  subtitle: "Evangelizar, adorar, discipular y mostrar compasión",
  link: "/misiones/",
  image: {
    src: assetUrl("mission_worship_speaker.png"),
    alt: "Líder de adoración y predicación en la congregación"
  }
}, {
  id: 3,
  title: "AFILIACIONES",
  subtitle: "Comunión global de creyentes e iglesias unidas",
  link: "/ministerios/",
  image: {
    src: assetUrl("affiliations_congregation_joy.png"),
    alt: "Miembros alegres de la congregación en comunidad"
  }
}, {
  id: 4,
  title: "OFICINA NACIONAL",
  subtitle: "Sede central de servicios y ministerios ejecutivos",
  link: homeUrl("contacto/"),
  image: {
    src: assetUrl("national_office_facade.webp"),
    alt: "Fachada arquitectónica del edificio de la Oficina Nacional"
  }
}];
export default function AssembliesCarousel() {
  const scrollerRef = useRef<HTMLDivElement | null>(null);
  const scrollCards = (direction: -1 | 1) => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    scroller.scrollBy({
      left: direction * scroller.clientWidth * 0.85,
      behavior: "smooth"
    });
  };
  return <section id="aboutassembliescarousel" data-nav="light" className="acad-about-links bg-background py-16 md:py-24 overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-10 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
          <div className="flex flex-wrap items-center gap-3">
            <span className="inline-flex items-center justify-center rounded-full bg-destructive px-3.5 py-1 text-xs font-bold uppercase tracking-wider text-destructive-foreground">
              SOBRE
            </span>
            <h2 className="text-2xl font-black uppercase tracking-tight text-foreground sm:text-3xl md:text-4xl">
              ASAMBLEAS DE DIOS
            </h2>
          </div>

          {/* Navigation Controls */}
          <div className="flex items-center gap-2">
            <Button variant="outline" size="icon" aria-label="Diapositiva anterior" className="size-10 rounded-full border-border bg-background text-foreground transition-all hover:bg-muted" onClick={() => scrollCards(-1)}>
              <ArrowLeft className="size-4" />
            </Button>
            <Button variant="outline" size="icon" aria-label="Siguiente diapositiva" className="size-10 rounded-full border-border bg-background text-foreground transition-all hover:bg-muted" onClick={() => scrollCards(1)}>
              <ArrowRight className="size-4" />
            </Button>
          </div>
        </div>

        {/* Carousel Container */}
        <div className="relative w-full overflow-hidden">
          <div ref={scrollerRef} className="acad-card-scroller w-full pb-4">
            {cardsData.map((card, i) => <article key={card.id} data-index={i} className="acad-card-slide !h-auto flex-shrink-0">
                <div className="group relative flex h-[420px] w-full flex-col justify-between overflow-hidden rounded-2xl bg-card shadow-md transition-shadow hover:shadow-xl">
                  {/* Background Image */}
                  <div className="absolute inset-0 z-0 overflow-hidden">
                    <img src={card.image.src} alt={card.image.alt} loading="lazy" className="size-full object-cover transition-transform duration-500 ease-out group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-black/10" />
                  </div>

                  {/* Top Floating Badge Arrow */}
                  <div className="relative z-10 flex justify-end p-4">
                    <div className="flex size-9 items-center justify-center rounded-full bg-background/90 text-foreground shadow-sm backdrop-blur-sm transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5">
                      <ArrowUpRight className="size-4" />
                    </div>
                  </div>

                  {/* Bottom White Overlay Panel */}
                  <div className="relative z-10 m-3 rounded-xl bg-background/95 p-4 shadow-sm backdrop-blur-sm sm:p-5">
                    <h3 className="font-default text-lg font-bold tracking-tight text-foreground uppercase sm:text-xl">
                      {card.title}
                    </h3>
                    <p className="mt-1 line-clamp-1 text-xs text-muted-foreground">
                      {card.subtitle}
                    </p>

                    <div className="mt-4 pt-2">
                      <Button asChild variant="default" size="sm" className="w-full rounded-md bg-foreground text-background shadow-none transition-opacity hover:opacity-90">
                        <Link to={card.link} className="flex items-center justify-center gap-1.5 text-xs font-semibold uppercase tracking-wider">
                          <span>CONOCER MÁS</span>
                          <ArrowUpRight className="size-3.5" />
                        </Link>
                      </Button>
                    </div>
                  </div>
                </div>
              </article>)}
          </div>
        </div>
      </div>
    </section>;
}
